module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-report-4.4fe6afe6.svg";